<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(2.683797, 0, 0, 2.007916, -84.150124, 0.000007)">
    <path
      d="M134.545,4.895L64.588,120.736c-4.259,7.049-1.028,12.76,7.196,12.76h45.976 c8.235,0,12.7,6.298,9.975,14.071l-33.347,95.107c-2.725,7.778-1.262,8.496,3.263,1.621l86.546-131.582 c4.525-6.886,1.518-12.455-6.712-12.455H121.97c-8.235,0-12.836-6.347-10.296-14.174L137.64,6.315 C140.191-1.518,138.81-2.148,134.545,4.895z"
    />
  </g>
</template>
